import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DescrizioneMedicoFamiglia, AutorizzazioneOperatore } from '@hm_app/@core/models/utente';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ngx-verifica-medico',
    templateUrl: './verifica-medico.component.html',
    styleUrls: ['./verifica-medico.component.scss'],
})
export class VerificaMedicoComponent implements OnInit {

    @Input() desc_medico_famiglia: DescrizioneMedicoFamiglia;
    @Input() autorizzazione: AutorizzazioneOperatore;

    @Input() can_request: boolean = true;

    @Output() onAuth: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private activeModal: NgbActiveModal,
        protected modalService: NgbModal) { }

    ngOnInit() {
    }

    closeModal(okAction: boolean) {
        // this.action.emit(okAction);

        this.activeModal.close();
    }

    autorizza() {
        this.onAuth.emit(this.desc_medico_famiglia);
        this.activeModal.close();

    }

}
